import { Button } from "@vitalsource/vstui";
import styled from "styled-components";
import { createThemedComponent } from "@vitalsource/vstui/themes";
import { cloud } from "@vitalsource/vstui/colors";

const CustomRoundFocus = createThemedComponent(Button, {
  Button_borderRadius: "100%",
  Button_minHeight_medium: 46,
  Button_borderWidth: "1px",
  Button_paddingHorizontal_fullWidth: "10px",
  Button_fontWeight_naked: "400",
  Button_fontSize_medium: "20px",
  Button_borderColor_neutralNaked: cloud.getShade(4),
  Button_backgroundColor_neutralNaked: cloud.getShade(1),
  Button_backgroundColor_neutralNaked_hover: cloud.getShade(1),
  Button_backgroundColor_neutralNaked_focus: cloud.getShade(1),
  Button_backgroundColor_neutralNaked_active: cloud.getShade(1),
  Button_borderColor_neutralNaked_hover: cloud.getShade(4),
  Button_borderColor_neutralNaked_active: cloud.getShade(4),
  Button_borderColor_neutralNaked_focus: cloud.getShade(4),
  Button_paddingHorizontal_withIconMedium: "12px",
  Button_boxShadow_neutralNaked_focus: (p: any) =>
    `0 0 0 2px #fff, 0 0 0 4px ${p.theme.vstui.color.primary.getShade(6)}`,
});

const RoundBorderButton = styled(CustomRoundFocus)<{
  label: string;
  padding: number;
}>`
  [aria-expanded="true"] {
    &:hover {
      border: 2px solid ${p => p.theme.vstui.color.primary.getShade(6)};
    }
    // Button_paddingHorizontal_fullWidth 10px &
    // Button_boxShadow_neutralNaked_focus conflict
    // Reduce padding by 1px when expanded to prevent jump
    padding: 0 9px;
    border: 2px solid ${p => p.theme.vstui.color.primary.getShade(6)};
    color: ${p => p.theme.vstui.color.primary.getShade(6)};
  }
`;

export default RoundBorderButton;
